import {CardOo} from '../../components/CardOo/CardOo';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {ReservationPrices} from './ReservationPrices';
import {hasReservationPrices} from './utils/hasReservationPrices';

type ReservationCardType = {
  isExpired?: boolean;
};

export function ReservationCard(_props: ReservationCardType) {
  const offer = useGetOnlineOfferData();

  if (!hasReservationPrices(offer)) {
    return null;
  }

  return (
    <CardOo backgroundColor="semantic.bg.subtle">
      <ReservationPrices />
    </CardOo>
  );
}
